<template>
    <div class="page">
        <div class="workspace">
            <div class="ws-unit">
                <div class="ws-unit-header ">
                    <div>
                    </div>
                    <div class="ws-unit-toolbar">
                        <el-form :inline="true">
                            <el-form-item>
                            <el-input placeholder="请输入内容" v-model="filter.keyword" clearable @clear="onSearch" class="input-with-select" size="mini">
                              <el-select v-model="filter.column" slot="prepend" placeholder="请选择" size="mini" style="width: 100px">
                                <el-option label="订单号" value="number"></el-option>
                                <el-option label="需求" value="subject"></el-option>
                                <el-option label="客户姓名" value="client_name"></el-option>
                                <el-option label="客户电话" value="client_phone"></el-option>
                                <el-option label="客户公司" value="client_company"></el-option>
                              </el-select>
                              <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
                            </el-input>
                          </el-form-item>
                            <el-form-item>
                                <el-radio-group
                                    v-model="filter.state"
                                    size="mini"
                                    @change="onSearch"
                                >
                                    <el-radio-button label="所有"></el-radio-button>
                                    <el-radio-button label="未支付"></el-radio-button>
                                    <el-radio-button label="已支付"></el-radio-button>
                                    <el-radio-button label="已完成"></el-radio-button>
                                    <el-radio-button label="已评价"></el-radio-button>
                                    <el-radio-button label="已中止"></el-radio-button>
                                </el-radio-group>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
                <div class="ws-unit-body">
                    <order-table ref="table" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import OrderTable from "./Table";

export default {
    name: "Order",
    components: {
        OrderTable
    },
    data: function() {
        return {
            filter: {
                state: '已支付',
                column:'number',
                keyword: null
            }
        };
    },
    methods: {
      onSearch(){
        this.$refs.table.loadData(1);
      }
    }
};
</script>

<style scoped>
</style>